var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11651_107925)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M22.9344 0H9.06401C3.64161 0 0 3.80481 0 9.46721V22.5344C0 28.1952 3.64161 32 9.06401 32H22.9328C28.3552 32 32 28.1952 32 22.5344V9.46721C32 3.80481 28.3568 0 22.9344 0Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6649 13.5834H19.8419C18.5281 13.5857 17.4638 14.6234 17.4614 15.9044C17.4596 17.1882 18.5251 18.2305 19.8419 18.2323H22.6673V18.4362C22.6673 20.6757 21.3097 22 19.0122 22H12.9897C10.6916 22 9.33398 20.6757 9.33398 18.4362V13.5586C9.33398 11.3191 10.6916 10 12.9897 10H19.0099C21.3073 10 22.6649 11.3191 22.6649 13.5586V13.5834ZM12.4937 13.5782H16.2537H16.2561H16.2608C16.5423 13.5771 16.7699 13.3535 16.7687 13.0784C16.7675 12.804 16.5375 12.5821 16.2561 12.5833H12.4937C12.214 12.5844 11.987 12.8057 11.9858 13.079C11.9847 13.3535 12.2122 13.5771 12.4937 13.5782Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.691 16.1974C18.8304 16.8315 19.3864 17.2777 20.0211 17.2661H22.1877C22.4518 17.2661 22.666 17.0473 22.666 16.7769V15.0893C22.6654 14.8195 22.4518 14.6002 22.1877 14.5996H19.9701C19.2481 14.6019 18.6649 15.2012 18.666 15.9398C18.666 16.0262 18.6746 16.1127 18.691 16.1974Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 16.6009C20.3688 16.6009 20.6673 16.3024 20.6673 15.9342C20.6673 15.5661 20.3688 15.2676 20.0007 15.2676C19.6325 15.2676 19.334 15.5661 19.334 15.9342C19.334 16.3024 19.6325 16.6009 20.0007 16.6009Z",
    fill: "#CE2600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11651_107925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.be5e9d28080d084efb43342c34f55659.svg";
export { ForwardRef as ReactComponent };